import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Core: Importera artiklar från Visma", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Hämta artiklar från Visma.", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: null
}, "Välj kampanj", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "ms-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCampaign) = $event)),
            class: "form-control"
          }, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: campaign.id
              }, [
                (campaign.active)
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: campaign
                    }, _toDisplayString(campaign.id) + " : " + _toDisplayString(campaign.name), 9, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedCampaign]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importArticles && _ctx.importArticles(...args))),
            disabled: _ctx.importingArticles
          }, [
            (!_ctx.importingArticles)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Importera"))
              : _createCommentVNode("", true),
            (_ctx.importingArticles)
              ? (_openBlock(), _createBlock(_component_fa_icon, {
                  key: 1,
                  icon: "spinner"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.importStatus)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.importStatus), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}